import { Navigate } from 'react-router-dom';

import AgencyDashboard from '@/routes/Agency/Dashboard';
import useDashboardRoute from '@/hooks/useDashboardRoute';
import ROUTES from '@/routes/routes';

// "/" is the dashboard entry point, and as of GRAVY-10832 that means Dashboard
// V2 for tenant admins — the sidebar's "Dashboard" link points straight at
// `/dashboard-v2`, and this keeps bookmarks, the header logo and every
// `navigate('/')` in the app landing on the same dashboard the link does.
//
// Client and helpdesk admins are NOT redirected: Dashboard V2 is tenant-admin
// only on both the route and the API, so "/" stays their classic dashboard.
//
// Tenant admins reach the classic dashboard through `/dashboard-v1` instead
// (the link on the Dashboard V2 page), which this redirect does not touch.
const DashboardEntry = () => {
  const { isDashboardV2Admin } = useDashboardRoute();

  return isDashboardV2Admin ? (
    <Navigate replace to={`/${ROUTES.dashboardV2}`} />
  ) : (
    <AgencyDashboard />
  );
};

export default DashboardEntry;
